// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Vswt","textarea":"styles_textarea__3vy-g"};